import React from 'react';
import { X, Zap } from 'lucide-react';

const About = ({ isOpen, onClose, t, isMobile }) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 20, animation: 'fadeIn 0.2s ease-out'
        }}>
            {/* Overlay */}
            <div
                onClick={onClose}
                style={{
                    position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.7)',
                    backdropFilter: 'blur(4px)'
                }}
            />

            {/* Modal Content */}
            <div style={{
                position: 'relative', width: isMobile ? '92%' : '100%', maxWidth: 500,
                background: t.bgCard, borderRadius: 2, border: `1.5px solid ${t.ink}`,
                overflow: 'hidden'
            }}>
                <button
                    onClick={onClose}
                    style={{
                        position: 'absolute', top: 16, right: 16,
                        width: 32, height: 32, borderRadius: '50%',
                        border: 'none', background: t.bgInput, color: t.textMuted,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        cursor: 'pointer', transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.color = t.text}
                >
                    <X size={18} />
                </button>

                <div style={{ padding: isMobile ? 24 : 40, textAlign: 'center' }}>
                    <div style={{
                        width: isMobile ? 56 : 64, height: isMobile ? 56 : 64, borderRadius: isMobile ? 12 : 16, background: t.accent,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 24px', color: '#fff'
                    }}>
                        <Zap size={isMobile ? 24 : 32} />
                    </div>
                    <h1 style={{ fontFamily: t.disp, fontSize: isMobile ? 22 : 26, fontWeight: 700, color: t.text, margin: '0 0 8px 0', letterSpacing: '-0.02em' }}>Prexo</h1>
                    <p style={{ fontFamily: t.mono, fontSize: isMobile ? 11 : 11, color: t.textMuted, margin: '0 0 28px 0', letterSpacing: '0.06em', textTransform: 'uppercase' }}>Inteligência de precificação para marketplaces</p>

                    <div style={{ background: t.bgInput, padding: 22, borderRadius: 0, border: `1.5px solid ${t.ink}`, textAlign: 'left' }}>
                        <h2 style={{ fontFamily: t.disp, fontSize: 16, fontWeight: 700, color: t.text, margin: '0 0 12px 0' }}>Nossa Missão</h2>
                        <p style={{ fontSize: 14, color: t.textSecondary, lineHeight: 1.6, margin: 0 }}>
                            O Prexo nasceu da necessidade de simplificar a vida do seller brasileiro. Acreditamos que a lucratividade começa em uma precificação bem feita, e nossa ferramenta fornece as métricas necessárias para que você tome decisões baseadas em dados, não em palpites.
                        </p>
                    </div>

                    <div style={{ marginTop: 32, color: t.textMuted, fontSize: 11, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                        <p style={{ margin: 0 }}>© 2025 Prexo - Todos os direitos reservados.</p>
                        <p style={{ margin: '4px 0 0 0', opacity: 0.7 }}>Versão 5.8.5</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
